
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDDAEKN8ofHMKqX7J13oMvbGurubgkerHxoM1Mes6JhkMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/index.vue?macro=true";
import { default as _91order_93VXTSwlVRnQvxRw6R0o0W_45smF8UO4bOyF3PelqwmpjXkMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/b/[order].vue?macro=true";
import { default as test5tA5qAccydcnb1Zh20ULqoEichW7lAxaUE609qeKEqMMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/test.vue?macro=true";
import { default as indexWEUOiK4UQb7_45roWjeuKaSN9IuSEviJZicV9uKuJREf4Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/index.vue?macro=true";
import { default as _91month_93iEmTCBm5JmhmHHgVqkLLKFivYdR9EvT3sHFZRi4bka8Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/calendar/[month].vue?macro=true";
import { default as _91kw_93jNfFlO7QBR59RP8uuTvGzZz0ZqvPi6dI12T4BiagDXsMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/week/[kw].vue?macro=true";
import { default as certificateERwIFGbbAqvTeWhX1Ae8u7jB5MAu_45j8gFWivpnzI_45E0Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/setup/certificate.vue?macro=true";
import { default as _91order_93HIcthZjbKbY9IvQmKrbRGgYXTXU225vZDb4fQG8h4HYMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/day/[date]/[order].vue?macro=true";
import { default as _91date_93YLkpPzOEQdxZgj_Ynjl2gHOy_45eJVZ2W7tImoyfmX5QsMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/day/[date].vue?macro=true";
import { default as sentry_45example_45pageGNLHCU8Yt3WkxO4ed_45ledlu405PuzAGw1gPQKGwyy5kMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/sentry-example-page.vue?macro=true";
import { default as _91date_93lNd3qrpKYhcA5EUEjCimpEeuoYgkdnv792gmJYnoNP8Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/routeplanning/[date].vue?macro=true";
import { default as index_45_WwNXdgHm_45hPHEvCqGvBa9Yf1Tqulr_3nmOAH5BZu0Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/[date]/index.vue?macro=true";
import { default as _91month_93eaksVgs8xZNXJUYtEOWj5fPn8RjEvsAX_K_45FHyPO9wgMeta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/month/[month].vue?macro=true";
import { default as _91route_93_InCzHdac27_45G1FBF0GjWV2sym8ctxJ5G8_45Xnk2YJ_4Meta } from "/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/[date]/[route].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/index.vue")
  },
  {
    name: "b-order",
    path: "/b/:order()",
    meta: _91order_93VXTSwlVRnQvxRw6R0o0W_45smF8UO4bOyF3PelqwmpjXkMeta || {},
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/b/[order].vue")
  },
  {
    name: "delivery-test",
    path: "/delivery/test",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/test.vue")
  },
  {
    name: "kitchen",
    path: "/kitchen",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/index.vue")
  },
  {
    name: "calendar-month",
    path: "/calendar/:month()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/calendar/[month].vue")
  },
  {
    name: "kitchen-week-kw",
    path: "/kitchen/week/:kw()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/week/[kw].vue")
  },
  {
    name: "setup-certificate",
    path: "/setup/certificate",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/setup/certificate.vue")
  },
  {
    name: "kitchen-day-date",
    path: "/kitchen/day/:date()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/day/[date].vue"),
    children: [
  {
    name: "kitchen-day-date-order",
    path: ":order()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/day/[date]/[order].vue")
  }
]
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/sentry-example-page.vue")
  },
  {
    name: "routeplanning-date",
    path: "/routeplanning/:date()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/routeplanning/[date].vue")
  },
  {
    name: "delivery-date",
    path: "/delivery/:date()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/[date]/index.vue")
  },
  {
    name: "kitchen-month-month",
    path: "/kitchen/month/:month()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/kitchen/month/[month].vue")
  },
  {
    name: "delivery-date-route",
    path: "/delivery/:date()/:route()",
    component: () => import("/home/yannick/Documents/ensolarado/clients/refueat/refueat-app/pages/delivery/[date]/[route].vue")
  }
]